<template>
    <div class="business_cooperation_container" id="business_cooperation">
        <div class="business_cooperation_main">
            <div class="business_cooperation_title">{{ $t('index.business_cooperation_title') }}</div>
            <div class="business_cooperation_desc">{{ $t('index.business_cooperation_desc') }}</div>
            <div class="business_cooperation_step_box">
                <div class="step_box">
                    <div class="step_num">01</div>
                    <div class="step_tit">{{ $t('index.business_cooperation_step01_tit') }}</div>
                </div>

                <div class="step_box">
                    <span class="step_num">02</span>
                    <div class="step_tit">{{ $t('index.business_cooperation_step02_tit') }}</div>
                </div>

                <div class="step_box">
                    <div class="step_num">03</div>
                    <div class="step_tit">{{ $t('index.business_cooperation_step03_tit') }}</div>
                </div>

                <div class="step_box">
                    <div class="step_num">04</div>
                    <div class="step_tit">{{ $t('index.business_cooperation_step04_tit') }}</div>
                </div>
            </div>

            <div class="business_cooperation_form_box">
                <div class="business_cooperation_form">
                    <div class="form_title">{{ $t('index.business_cooperation_form_tit') }}</div>
                    <div class="form_body">
                        <el-form ref="form" :model="form" :rules="rules">
							<el-form-item prop="name">
								<el-input v-model="form.name" :placeholder="$t('index.business_cooperation_form_placeholder_name')"></el-input>
							</el-form-item>

							<el-form-item prop="phone" class="phone-input-sty">
								<el-input 
									v-if="false" 
									v-model="form.phone" 
									:placeholder="$t('index.business_cooperation_form_placeholder_phone')"></el-input>
								<vue-phone-number-input 
									v-model="form.phone" 
									:default-country-code="countryCode" 
									@update="onUpdate" 
									id="midPhone" />
							</el-form-item>
						
							<el-form-item prop="company">
								<el-input v-model="form.company" :placeholder="$t('index.business_cooperation_form_placeholder_company')"></el-input>
							</el-form-item>
							
							<el-form-item prop="email">
								<el-input v-model="form.email" :placeholder="$t('index.business_cooperation_form_placeholder_email')"></el-input>
							</el-form-item>

							<el-button type="primary" @click="submitForm('form')">
								{{ $t('index.business_cooperation_form_button') }}
							</el-button>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formRules          from '@/utils/formRules';
import { postFormJoinUs } from '@/api/joinUsApi';

export default {
    name: 'CommonBusinessCooperationPc',
    data() {
        return {
			tips       : 'Hello World',
			// About Phone
			results    : null,
			countryCode: 'CN',
			form       : {
				name       : '',
				countryCode: '',// 86
				phone      : '',// 132 1234 5678
				company    : '',
				email      : ''
			},
			rules: {
				name   : formRules.nameRules(this),
				phone  : formRules.phoneRules(this),
				company: formRules.companyRules(this),
				email  : formRules.emailRules(this)
			}
        }
    },

    methods: {
		// 获取电话信息的不同样式
		onUpdate(payload)
		{
			this.results = payload;
			// console.log('=== onUpdate__results >>>', this.results);

			// 让ERROR隐藏
			var botPhone = document.getElementById('midPhone');
			if(botPhone.nextElementSibling)
			{
				var nextElement = botPhone.nextElementSibling;
				nextElement.style.display = 'none';
			}

			this.$set(this.form, 'countryCode', this.results.countryCallingCode);// 86
			this.$set(this.form, 'phone', this.results.phoneNumber);             // 132 1234 5678
    	},

        // Submit Form
		async submitForm(formName)
		{
			this.$refs[formName].validate(async (valid) => {
				if(valid)
				{
					// Req
					/* console.log('=== submitForm__this__form >>>', this.form);
					return; */

					const res = await postFormJoinUs(this.form);
					// console.log('=== submitForm > res >>>', res);

					// 关闭输入弹窗
					// this.closeFormDialog();
					this.$refs.form.resetFields();
					
					if(res && res.errCode === 0)
					{
						this.$message({
							type       : 'success',
							customClass: 'zdyElMsgMobile',
							message    : res.errMsg
						});
					}
					else if(res && res.errCode !== 0)
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsgMobile',
							message    : res.errMsg
						});
					}
					else
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsgMobile',
							message    : 'The operation failed. Please try again later~'
						});
					}
				}
				else
				{
					// console.log('=== this.form.phone >>>', this.form.phone);
					// console.log('=== this.form.valid >>>', valid);

					// 提交时：未输入手机号
					if(this.form.phone === null)
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsgMobile',
							message    : 'The operation failed. Please try again later~'
						});
					}
					else
					{
						// console.log('=== this.form.phone >>>', this.form.phone);
						const phoneNumberWithoutSpaces = this.form.phone.replace(/\s/g, '');// 移除所有空格
						const phoneNumberLength        = phoneNumberWithoutSpaces.length;
						if(phoneNumberLength < 5 || phoneNumberLength > 30)
						{
							this.$message({
								type       : 'warning',
								customClass: 'zdyElMsgMobile',
								message    : 'Phone format error~'
							});
						}
					}
					
					console.log('=== ERROR SUBMIT <<<');
					return false;
				}
			});
		}
    }
}
</script>

<style lang="less" scoped>
.business_cooperation_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:var(--com-base-container-wm);height:auto;
	background:linear-gradient(180deg, #FFF, #F4F8FF, #DBE9FF, #D0E2FF);
	padding-bottom:50px;
	.business_cooperation_main{
		position:relative;
		margin:0 auto;padding-top:75px;
		width:var(--com-base-container-w);height:inherit;
		/* background:#CCC; */
		.business_cooperation_title{
			height:50px;line-height:50px;
			font-size:var(--com-base-fz-58);font-weight:bold;color:var(--com-main-ft-color);text-align:center;
		}
		.business_cooperation_desc{
			display:flex;justify-content:center;align-items:center;
			margin-top:10px;
			height:80px;line-height:80px;
			font-size:var(--com-base-fz-28);font-weight:normal;color:#676D77;text-align:center;
		}
		.business_cooperation_step_box{
			width:100%;margin-top:50px;
			display:flex;justify-content:center;align-items:center;
			flex-wrap:wrap;
			gap:20px;
			.step_box{
				width:332px;height:88px;
				border:2px solid #FBFDFF;border-radius:14px;
				background:#FFF;
				display:flex;justify-content:flex-start;align-items:center;
				.step_num{
					width:100px;
					font-size:var(--com-base-fz-50);font-weight:bold;font-style:italic;color:#1D55FF;text-align:center;
					text-shadow:3px 4px 4px #B7D0F4;
				}
				.step_tit{
					flex:1;
					font-size:var(--com-base-fz-28);color:#676D77;text-align:center;
				}
			}
			.step_arrow{
				width:20px;height:16px;
				img{
					width:inherit;height:inherit;
				}
			}
		}
		.business_cooperation_form_box{
			border:2px solid #F6FAFF;border-radius:18px;
			width:var(--com-base-content-wm);height:auto;
			margin:0 auto;margin-top:50px;padding:30px 20px;
			background:#E7F0FF;
			.business_cooperation_form{
				width:100%;
				display:flex;flex-direction:column;justify-content:center;align-items:center;
				.form_title{
					width:100%;height:40px;line-height:40px;
					font-size:var(--com-base-fz-24);font-weight:bold;color:var(--com-main-ft-color);text-align:center;
				}
				.form_body{
					width:100%;
					margin-top:30px;
					/deep/ .el-form{
						display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
						.el-form-item{
							margin-bottom:35px !important;
							.el-form-item__content{
								.el-input{
									font-size:var(--com-base-fz-16);
									input.el-input__inner{
										width:618px;height:88px;line-height:1;
										padding:0 35px;
										border-radius:44px !important;
										border:1px solid #FFF;
										font-size:var(--com-base-fz-26);color:#5B77A1;
										background:#FAFBFC;
										&:focus{
											border-color:#409EFF;
										}
									}
									input.el-input__inner::placeholder{
										font-size:var(--com-base-fz-26);color:#C3C9D2;
									}
								}
								.el-form-item__error{
									padding-top:4px;padding-left:40px;
									font-size:var(--com-base-fz-20);
								}
							}
						}
						button{
							width:310px;height:88px;
							border-radius:44px;border:none;
							background:#1D55FF;
							span{
								font-size:var(--com-base-fz-28);font-weight:bold;color:#FFF !important;
							}
						}
						.phone-input-sty, 
						.phone-input-sty .el-form-item__content,
						.vue-phone-number-input{
							flex-direction:row !important;
							.select-country-container{
								width:200px !important;min-width:200px;max-width:200px;
								margin-right:20px;
							}
							.country-selector{
								width:200px;height:94px !important;
								.country-selector__label{display:none;}
								.country-selector__country-flag{
									display:none;
									top:43px;left:20px;
								}
								.country-selector__input{
									height:94px;min-height:94px !important;line-height:90px;
									border:1px solid #F3F3F7;
									border-top-left-radius:44px !important;
									border-top-right-radius:18px !important;
									border-bottom-right-radius:18px !important;
									border-bottom-left-radius:44px !important;
									/* border-right:none !important; */
									font-size:var(--com-base-fz-26);color:#5B77A1;
									background:#FAFBFC;
									/* padding-left:70px; */
									transition:all .25s cubic-bezier(.645,.045,.355,1);
								}
								.country-selector__toggle{
									right:30px !important;
									svg.country-selector__toggle__arrow{
										width:30px !important;height:30px !important;
										path.arrow{
											fill:#5B77A1;
										}
									}
								}
								&.has-value{
									.country-selector__input{
										padding-top:unset !important;
									}
								}
							}
							.country-selector__label, .input-tel__label{
								display:none;
								top:-10px !important;left:11px !important;
								font-size:var(--com-base-fz-11);
							}
							.country-selector.has-value .country-selector__label{
								font-size:var(--com-base-fz-11);
							}
							.country-selector__list{
								left:0px;top:100px;
								width:620px !important;min-width:620px !important;
								height:250px !important;max-height:250px !important;
								border-radius:18px !important;
								background:#FAFBFC;
								.country-selector__list__item{
									width:620px !important;min-width:620px !important;
									background:transparent !important;
									font-size:var(--com-base-fz-24);color:#9DA2AB;
									.dots-text{
										color:#9DA2AB;
									}
									div{
										align-items:flex-start;
									}
								}
								.selected{
									.dots-text{
										color:#90A4C3;
									}
								}
							}			
							.input-tel{
								width:400px !important;height:94px !important;
								min-height:94px !important;
								.input-tel__input{
									height:inherit;min-height:48px !important;
									border:1px solid #F3F3F7;
									border-top-left-radius:18px !important;
									border-top-right-radius:44px !important;
									border-bottom-right-radius:44px !important;
									border-bottom-left-radius:18px !important;
									/* border-left:none !important; */
									font-size:var(--com-base-fz-26);color:#5B77A1;
									background:#FAFBFC;
									padding-top:unset !important;
								}
								input.input-tel__input::placeholder{
									font-size:var(--com-base-fz-26);color:#C3C9D2;
								}
							}
							.country-selector__list__item__flag-container{
								display:none;
							}
						}
					}
				}
			}
		}
	}
}
/deep/ .zdyElMsg .el-message__content{
	font-size:var(--com-base-fz-24);
}
</style>